import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const GROUPS = [
  { title: "Program", items: [
    { q: "How long is the program?", a: "The program runs 90 days across three phases (Foundation, Build, Scale) — a total of twelve weeks." },
    { q: "Is this an online course?", a: "No. It is a mentorship program combining online curriculum, live coaching, templates, done-with-you implementation and hands-on warehouse training." },
    { q: "How many students are accepted?", a: "Only 15 students per cohort." },
    { q: "What happens after the 90 days?", a: "You retain access to the Lifetime University Portal, private community, monthly live Q&A and alumni events as defined in the signed agreement." },
    { q: "What is included in the Lifetime University Portal?", a: "Templates, contracts, safety manuals, marketing resources, vendor information, checklists and eligible future updates." },
  ]},
  { title: "Eligibility", items: [
    { q: "Do I need an existing inflatable business?", a: "No. The program serves both aspiring entrepreneurs and existing operators." },
  ]},
  { title: "Investment & Payment", items: [
    { q: "Is the program investment refundable?", a: "Refund and cancellation terms are governed by the signed Membership Enrollment and Mentorship Agreement. See the Refund Policy for the current published summary; final terms are provided during enrollment." },
    { q: "Are payment arrangements available?", a: "Approved payment arrangements may be available for accepted applicants. This is discussed on the enrollment call." },
  ]},
  { title: "Travel & Hands-On Training", items: [
    { q: "Where is the hands-on training held?", a: "Hands-on training is held at the Bounce City Warehouse. The full address, cohort dates and travel guidance are shared with accepted students during enrollment." },
    { q: "Are travel and accommodation included?", a: "Travel and accommodation for the in-person hands-on training are the student's responsibility unless otherwise specified in the signed agreement." },
    { q: "Is equipment included?", a: "No. Equipment is not included. Vendor and financing guidance is provided." },
  ]},
  { title: "Funding", items: [
    { q: "Do you guarantee funding?", a: "No. Bounce City University does not guarantee funding, credit approvals, loan approvals or specific funding amounts." },
  ]},
  { title: "Results", items: [
    { q: "Do you guarantee income or profit?", a: "No. Results depend on individual effort, execution, market, capital, pricing and business decisions." },
    { q: "Will Bounce City University build my business for me?", a: "No. The program provides mentorship, systems, templates and implementation support. The student is responsible for building their business." },
  ]},
  { title: "Portal & Support", items: [
    { q: "Are software subscriptions included?", a: "No. Any recommended third-party software subscriptions are the student's responsibility." },
    { q: "Are legal, accounting and insurance services included?", a: "No. Educational guidance is provided; students must engage their own qualified professionals." },
  ]},
  { title: "Enrollment", items: [
    { q: "What happens after I apply?", a: "Your application is reviewed. Qualified applicants are invited to an enrollment conversation, followed by an acceptance decision." },
  ]},
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="bg-black text-white pt-36 md:pt-44 pb-24 min-h-screen">
      <div className="bcu-container">
        <p className="bcu-eyebrow bcu-eyebrow-gold">Frequently Asked Questions</p>
        <h1 className="mt-6 font-display text-white text-5xl md:text-7xl leading-[1.02] max-w-4xl font-medium">
          Answers before
          <span className="font-editorial italic font-medium text-[#D9A441]"> you apply.</span>
        </h1>

        <div className="mt-16 grid lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-3 hidden lg:block">
            <div className="sticky top-32">
              <div className="text-[11px] tracking-[0.28em] uppercase text-[#D9A441] font-semibold mb-5">Sections</div>
              <ul className="space-y-3 text-[15px]">
                {GROUPS.map((g, i) => (
                  <li key={g.title}><a href={`#g-${i}`} className="text-[#A9A9A9] hover:text-white transition-colors">{g.title}</a></li>
                ))}
              </ul>
            </div>
          </aside>

          <div className="lg:col-span-9 space-y-14">
            {GROUPS.map((g, gi) => (
              <div key={g.title} id={`g-${gi}`} className="scroll-mt-32">
                <div className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[#D9A441]">{g.title}</div>
                <Accordion type="single" collapsible className="mt-4">
                  {g.items.map((it, i) => (
                    <AccordionItem key={i} value={`g${gi}-i${i}`} className="border-[rgba(255,255,255,0.08)]">
                      <AccordionTrigger data-testid={`faq-${gi}-${i}`} className="text-left font-body font-medium text-white text-lg md:text-xl hover:text-[#D9A441] py-6">{it.q}</AccordionTrigger>
                      <AccordionContent className="text-[#A9A9A9] text-[16px] leading-[1.75] pb-6">{it.a}</AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-[rgba(217,164,65,0.24)] max-w-3xl">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#D9A441] font-semibold">Program Disclaimer</div>
          <p className="mt-4 text-[#A9A9A9] text-[16px] leading-[1.75]">Bounce City University provides business education, mentorship, systems, templates and support. Individual results vary. We do not guarantee funding, income, profit, business success or specific financial outcomes. Refund, cancellation and transfer terms are governed by the signed Membership Enrollment and Mentorship Agreement.</p>
          <p className="mt-6 text-[#A9A9A9] text-[15px]">Still have questions? <Link to="/contact" className="editorial-link">Contact the enrollment team</Link>.</p>
        </div>
      </div>
    </div>
  );
}
